import React, { useContext, useState, useEffect } from "react";
import { Layout, Menu, Typography, Drawer, Button } from "antd";
import {
  HomeOutlined,
  UsergroupAddOutlined,
  UserSwitchOutlined,
  SwapOutlined,
  TeamOutlined,
  IdcardOutlined,
  ClockCircleOutlined,
  FileSearchOutlined,
  ScanOutlined,
  BankOutlined,
  SafetyOutlined,
  ApartmentOutlined,
  CheckSquareOutlined,
  FileProtectOutlined,
  DollarOutlined,
  FileTextOutlined,
  FileAddOutlined,
  EditOutlined,
  LogoutOutlined,
  UserDeleteOutlined,
  AuditOutlined,
  EnvironmentOutlined,
  CalendarOutlined,
  LineChartOutlined,
  BarChartOutlined,
  PieChartOutlined,
  FundOutlined,
  NotificationOutlined,
  ReadOutlined,
  FileDoneOutlined,
  ExportOutlined,
  AlertOutlined,
  RiseOutlined,
  SolutionOutlined,
  MenuOutlined,
  FormOutlined
} from "@ant-design/icons";


import TeamAssessment from "../../TeamAssessment";
import PipApprovals from "../../PipApprovals";

import { AuthContext } from "../../../context/AuthContext";
import { useNavigation } from "../../../context/NavigationContext";
import DashboardHeader from "../../../components/dashboardheader/DashboardHeader";
import Footer from "../../../components/footer/Footer";
import ChatBot from "../../../components/ChatBot";

import CreateMrfHr from "../createmrfhr/CreateMrfHr";
import ViewRequisitions from "../viewrequisitions/ViewRequisitions";
import InterviewPage from "../../interviewpage/InterviewPage";
import HrArea from "../../announcement/hrarea/HrArea";
import HrViewAnnouncement from "../hrviewannouncement/HrViewAnnouncement";
import VerifiedCandidates from "../verifiedcandidates/VerifiedCandidates";
import AddHoliday from "../AddHoliday";
import ViewEmployees from "../../ViewEmployees";
import ApproveVenue from "../ApproveVenue";
import ViewEmployeeAttendance from "../ViewEmployeeAttendance";
import FingerHeadOffice from "../FingerPrintHead";
import AttendanceHead from "../AttendanceHead";
import FingerprintSite from "../FingerPrintSite";
import AttendanceSite from "../AttendanceSite";
import Leaves from "../../../components/employee/Leaves";
import Permission from "../../../components/employee/Permission";
import OffDay from "../../../components/employee/OffDay";
import Holidays from "../../employee/Holidays";
import EmpLeaves from "../EmpLeaves";
import EmpPermissions from "../EmpPermissions";
import EmpCompoff from "../EmpCompoff";
import CompoffApproval from "../../../components/hr/CompoffApproval";
import TeamCompoff from "../../../components/employee/TeamCompoff";
import Rfc from "../../../components/Rfc";
import SalaryDetails from "../SalaryDetails";
import HrIndex from "../HrIndex";
import OtApprovals from "../../../components/OtApprovals";
import ListTickets from "../../../components/ListTickets";
import ResignationRequests from "../../ResignationRequests";
import FinalSettlement from "../../payroll/FinalSettlement";
import EmployeeAttendanceReport from "../../../components/HrReports/EmployeeAttendanceReport";
import LeaveUtilizationReport from "../../../components/HrReports/LeaveUtilizationReport";
import EmployeeIdCards from "../EmployeeIdCards";
import DepartmentWisePayroll from "../../../components/HrReports/DepartmentWisePayroll";
import FixedSalary from "../FixedSalary";
import ProbationReview from "../../../components/employee/ProbationReview";
import OtReport from "../reports/OtReport";
import LeaveReport from "../reports/LeaveReport";
import CompoffReport from "../reports/CompoffReport";
import LateEarlyReport from "../reports/LateEarlyReport";
import OndutyReport from "../reports/OndutyReport";
import IdCardReport from "../reports/IdCardReport";
import CugReport from "../reports/CugReport";
import CheckListReport from "../reports/CheckListReport";
import SecondCheckList from "../reports/SecondCheckList";
import GrossSalary from "../reports/GrossSalary";
import ListNoc from "../../ListNoc"
import ExitInterview from "../../ExitInterview";
import PersmissionRequests from "../PermissionRequests";
import ShowSpecialPermission from "../../ShowSpecialPermission";
import ApproveTI from "../ApproveTI";
import RfcHr from "../RfcHr";
import PastOnduty from "../../employee/PastOnduty";
import ProbationReviewHr from "../ProbationReviewHr";
import StatusUpdation from "../StatusUpdation";
import ViewImproperHr from "../ViewImproperHr";
import Teamleaves from "../../../components/Teamleaves";
import TeamPermissions from "../../../components/TeamPermissions";
import HodChange from "../HodChange";
import TlChange from "../TlChange";
import ChangeTl from "../../payroll/ChangeTl";
import GetStatusChange from "../GetStatusChange";
import QuickView from "../../payroll/QuickView";
import ActiveEmployees from "../../payroll/ActiveEmployees";
import InactiveEmployees from "../../payroll/InactiveEmployees";
import EmpTransfer from "../EmpTransfer";
import EmployeeProfile from "../../EmployeeProfile";
// import CompoffApproval from "../../../components/hr/CompoffApproval";
import ExitClearanceApprovalPage from "../../ExitClearanceApprovalPage";
import FinalApprovalsList from "../FinalApprovalsList";
import ConfirmedEmployees from "../ConfirmedEmployees";
import FinalSettlementApprovalsQueue from "../FinalSettlementApprovalsQueue";


const { Sider, Content } = Layout;
const { Text } = Typography;

// Map each leaf key to its parent key(s) for open-state tracking
const keyParentMap = {
  verifiedcandidates: ["employee"],
  viewEmployees: ["employee"],
  activeEmployees: ["employee"],
  inactiveEmployees: ["employee"],
  idcard: ["employee"],
  quickView: ["employee"],
  hodChangeRequests: ["employee"],
  tlChangeRequests: ["employee"],
  changeEmpStatus: ["employee"],
  empTransfer: ["employee"],
  viewEmployeeRecords: ["attendance"],
  fingerHeadOffice: ["attendance"],
  attendanceHeadOffice: ["attendance"],
  fingerSiteOffice: ["attendance"],
  attendanceSiteOffice: ["attendance"],
  permissionRequests: ["attendance", "generalpermisssion"],
  rfc: ["attendance"],
  approvals: ["attendance"],
  compOffApprovals: ["attendance"],
  viewsalary: ["payroll"],
  salarydetails: ["payroll"],
  applyMRF: ["recruitement", "mrf"],
  viewRequisitions: ["recruitement", "mrf"],
  resignationRequests: ["exitmanagement"],
  noticePeriodEmployees: ["exitmanagement"],
  hrfinalstatement: ["exitmanagement"],
  resignedEmployees: ["exitmanagement"],
  employeeattendance: ["reports"],
  leaveutilization: ["reports"],
  grossreport: ["reports", "departmentwisepayroll"],
  otReport: ["reports"],
  leaveReport: ["reports"],
  ondutyReport: ["reports"],
  compoffReport: ["reports"],
  lateEarlyReport: ["reports"],
  IdCard: ["reports"],
  CugReport: ["reports"],
  checklistreport: ["reports"],
  secondChecklist: ["reports"],
  makeAnnouncement: ["announcement"],
  viewAnnouncement: ["announcement"],
  empleaves: ["leaves"],
  emppermissions: ["leaves"],
  empcompoffs: ["leaves"],
};

export default function HrDashboard() {
  const { authData } = useContext(AuthContext);
  const { registerNavigator } = useNavigation();
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(() => {
    // Priority: 1. LocalStorage (from notification click) 2. Fallback to 'home'
    const savedPage = localStorage.getItem("hrDashboardPage");
    if (savedPage) {
      // Once read, we can keep it, but ensure we don't default to home if a redirect just happened
      return savedPage;
    }
    return "home";
  });

  const isMobile = window.innerWidth < 768;

  const [openKeys, setOpenKeys] = useState(() => {
    const saved = localStorage.getItem("hrDashboardPage") || "home";
    return (keyParentMap[saved] || []);
  });

  // Register this dashboard's menu setter so NotificationBar / HrIndex can navigate into it
  useEffect(() => {
    const cleanup = registerNavigator((menuKey) => {
      setSelectedMenu(menuKey);
      const parents = keyParentMap[menuKey] || [];
      if (parents.length > 0) {
        setOpenKeys((prev) => Array.from(new Set([...prev, ...parents])));
      }
    });
    return cleanup;
  }, [registerNavigator]);

  useEffect(() => {
    localStorage.setItem("hrDashboardPage", selectedMenu);
  }, [selectedMenu]);

  const menuItems = [
    { key: "home", icon: <HomeOutlined />, label: "Dashboard" },
    {
      key: "employee",
      icon: <UsergroupAddOutlined />,
      label: "Employee Management",
      children: [
        { key: "verifiedcandidates", icon: <CheckSquareOutlined />, label: "Candidate Verification" },
        { key: "viewEmployees", icon: <TeamOutlined />, label: "View Employees" },
        { key: "activeEmployees", icon: <UserSwitchOutlined />, label: "Active Employees" },
        { key: "inactiveEmployees", icon: <UserSwitchOutlined />, label: "Inactive Employees" },
        { key: "idcard", icon: <IdcardOutlined />, label: "Employee ID Cards" },
        { key: "quickView", icon: <TeamOutlined />, label: "Quick View" },
        { key: "hodChangeRequests", icon: <SwapOutlined />, label: "Change HOD" },
        { key: "tlChangeRequests", icon: <UserSwitchOutlined />, label: "Change TL" },
        { key: "changeEmpStatus", icon: <FormOutlined />, label: "Employee Status Change" },
        { key: "empTransfer", icon: <SwapOutlined />, label: "Employee Transfer" },
      ],
    },
    {
      key: "onduty",
      icon: <CheckSquareOutlined />,
      label: "Onduty Requests",
    },
    {
      key: "improperApproval",
      icon: <CheckSquareOutlined />,
      label: "Improper Attendance",
    },
    {
      key: "attendance",
      icon: <ClockCircleOutlined />,
      label: "Attendance",
      children: [
        { key: "viewEmployeeRecords", icon: <FileSearchOutlined />, label: "Check-In & Check-Out" },
        { key: "fingerHeadOffice", icon: <ScanOutlined />, label: "Fingerprint – Head Office" },
        { key: "attendanceHeadOffice", icon: <BankOutlined />, label: "Attendance – Head Office" },
        { key: "fingerSiteOffice", icon: <SafetyOutlined />, label: "Fingerprint – Site Office" },
        { key: "attendanceSiteOffice", icon: <HomeOutlined />, label: "Attendance – Site Office" },

        {
          key: "generalpermisssion",
          icon: <ApartmentOutlined />,
          label: "General Permission",
          children: [
            {
              key: "permissionRequests",
              icon: <CheckSquareOutlined />,
              label: "Approve Permission Requests",
            },
          ],
        },

        // { key: "rfc", icon: <FileProtectOutlined />, label: "Permission Considerations" },
        { key: "approvals", icon: <CheckSquareOutlined />, label: "Status Updation Approvals" },
        { key: "compOffApprovals", icon: <CheckSquareOutlined />, label: "Compoff Approvals" },
      ],
    },
    {
      key: "payroll",
      icon: <DollarOutlined />,
      label: "Payroll",
      children: [
        { key: "viewsalary", icon: <FileTextOutlined />, label: "Actual Salary" },
        { key: "salarydetails", icon: <CalendarOutlined />, label: "Monthly Salary Statement" },
      ],
    },
    {
      key: "recruitement",
      icon: <SolutionOutlined />,
      label: "Recruitment",
      children: [
        {
          key: "mrf",
          icon: <FileAddOutlined />,
          label: "MRF",
          children: [
            { key: "applyMRF", icon: <EditOutlined />, label: "Apply MRF" },
            { key: "viewRequisitions", icon: <FileTextOutlined />, label: "View Requisitions" },
          ],
        },
      ],
    },
    {
      key: "exitmanagement",
      icon: <LogoutOutlined />,
      label: "Exit Management",
      children: [
        authData?.employee?.is_superuser && { key: "resignationRequests", icon: <FileTextOutlined />, label: "Resignation Requests" },
        { key: "noticePeriodEmployees", icon: <UserSwitchOutlined />, label: "Notice Period Employees" },
        { key: "hrfinalstatement", icon: <AuditOutlined />, label: "Final Settlement Approvals" },
        { key: "resignedEmployees", icon: <UserDeleteOutlined />, label: "Resigned Employees" },
        { key: "nocforms", icon: <UserDeleteOutlined />, label: "NOC Approvals" },
        { key: "finalapprovals", icon: <UserDeleteOutlined />, label: "NOC and Exit Interviews" },
        { key: "fnfapprovals", icon: <UserDeleteOutlined />, label: "Final settlement approvals" },
      ].filter(Boolean),
    },
    { key: "venue", icon: <EnvironmentOutlined />, label: "Venues" },
    { key: "holidaylist", icon: <CalendarOutlined />, label: "Holiday List" },
    {
      key: "reports",
      icon: <BarChartOutlined />,
      label: "Reports",
      children: [
        { key: "employeeattendance", icon: <CalendarOutlined />, label: "Employee Attendance Report" },
        { key: "leaveutilization", icon: <PieChartOutlined />, label: "Leave Utilization Report" },
        {
          key: "departmentwisepayroll",
          icon: <DollarOutlined />,
          label: "Payroll",
          children: [
            { key: "grossreport", icon: <FundOutlined />, label: "Gross Report" },
          ],
        },
        { key: "otReport", icon: <ClockCircleOutlined />, label: "OT Report" },
        { key: "leaveReport", icon: <FileDoneOutlined />, label: "Leave Report" },
        { key: "ondutyReport", icon: <ExportOutlined />, label: "On Duty Report" },
        { key: "compoffReport", icon: <AlertOutlined />, label: "Comp Off Report" },
        { key: "lateEarlyReport", icon: <AlertOutlined />, label: "Late In & Early Out Report" },
        { key: "IdCard", icon: <IdcardOutlined />, label: "ID Card Report" },
        { key: "CugReport", icon: <FileTextOutlined />, label: "CUG Report" },
        { key: "checklistreport", icon: <CheckSquareOutlined />, label: "Check List" },
        { key: "secondChecklist", icon: <CheckSquareOutlined />, label: "Check List 2" },
      ],
    },
    {
      key: "nocForms",
      icon: <FileProtectOutlined />,
      label: "NOC Forms",
    },
    {
      key: "announcement",
      icon: <NotificationOutlined />,
      label: "Announcement",
      children: [
        { key: "makeAnnouncement", icon: <EditOutlined />, label: "Make Announcement" },
        { key: "viewAnnouncement", icon: <ReadOutlined />, label: "View Announcements" },
      ],
    },
    {
      key: "leaves",
      icon: <CalendarOutlined />,
      label: "Leaves & Permissions",
      children: [
        { key: "empleaves", icon: <FileDoneOutlined />, label: "Leaves" },
        { key: "emppermissions", icon: <ExportOutlined />, label: "Permissions" },
        { key: "empcompoffs", icon: <AlertOutlined />, label: "Off Day Working" },
      ],
    },
    {
      key: "otapproval",
      icon: <ClockCircleOutlined />,
      label: "Over Time Requests",
    },
    {
      key: "viewAppraisals",
      icon: <RiseOutlined />,
      label: "View Appraisal Assessments",
    },
    {
      key: "tickets",
      icon: <AlertOutlined />,
      label: "Raised Tickets",
    },
    {
      key: "teamemployement",
      icon: <UserSwitchOutlined />,
      label: "Probation Employee",
    },
    {
      key: "confirmedemp",
      icon: <UserSwitchOutlined />,
      label: "Confirmed Employees",
    },
    {
      key: "pipapprovals",
      icon: <FileDoneOutlined />,
      label: "PIP Approvals",
    },

    // { key: "show_special_permission", icon: <FormOutlined />, label: "Show General Permisssion" },
    { key: "approve_technical_issue", icon: <FormOutlined />, label: "Approve Techincal Issues" },
  ].filter(Boolean);


  const renderContent = () => {
    switch (selectedMenu) {
      case "home":
        return (
          <>
            <HrIndex />
          </>
        );
      case "applyMRF":
        return <CreateMrfHr onSubmitSuccess={() => setSelectedMenu("viewRequisitions")} />;
      case "viewRequisitions":
        return <ViewRequisitions />;
      case "interview":
        return <InterviewPage />;
      case "makeAnnouncement":
        return <HrArea />;
      case "viewAnnouncement":
        return <HrViewAnnouncement />;
      case "chatbot":
        return <ChatBot />;
      case "verifiedcandidates":
        return <VerifiedCandidates />;
      case "holidaylist":
        return <AddHoliday />;
      case "viewEmployees":
        return <ViewEmployees />;
      case "venue":
        return <ApproveVenue />;
      case "viewEmployeeRecords":
        return <ViewEmployeeAttendance />;
      case "fingerHeadOffice":
        return <FingerHeadOffice />;
      case "attendanceHeadOffice":
        return <AttendanceHead />;
      case "fingerSiteOffice":
        return <FingerprintSite />;
      case "attendanceSiteOffice":
        return <AttendanceSite />;
      case "holidays":
        return <Holidays />;
      case "offDayDutyApply":
        return <OffDay />;
      case "permissions":
        return <Permission />;
      case "leaves":
        return <Leaves />;
      case "permissionRequests":
        return <PersmissionRequests />
      case "leaveRequests":
        return <EmpLeaves />
      case "empleaves":
        return <EmpLeaves />;
      case "emppermissions":
        return <EmpPermissions />
      case "empcompoffs":
        return <CompoffApproval />
      case "viewCompoff":
        return <CompoffApproval />
      case "compoffRequests":
        return <TeamCompoff />
      case "rfc":
        return <RfcHr />
      case "salarydetails":
        return <SalaryDetails />
      case "otapproval":
        return <OtApprovals viewMode="admin" />
      case "viewAppraisals":
        return <TeamAssessment />
      case "tickets":
        return <ListTickets />
      case "pipapprovals":
        return <PipApprovals />
      case "resignationRequests":
        return <ResignationRequests />
      case "hrfinalstatement":
        return <FinalSettlement />
      case "employeeattendance":
        return <EmployeeAttendanceReport />
      case "leaveutilization":
        return <LeaveUtilizationReport />
      case "idcard":
        return <EmployeeIdCards />
      case "departmentwisepayroll":
        return <DepartmentWisePayroll />
      case "viewsalary":
        return <FixedSalary />
      case "teamemployement":
        return <ProbationReviewHr />;
      case "confirmedemp":
        return <ConfirmedEmployees />;
      case "otReport":
        return <OtReport />
      case "leaveReport":
        return <LeaveReport />
      case "compoffReport":
        return <CompoffReport />
      case "lateEarlyReport":
        return <LateEarlyReport />
      case "ondutyReport":
        return <OndutyReport />
      case "IdCard":
        return <IdCardReport />
      case "CugReport":
        return <CugReport />
      case "checklistreport":
        return <CheckListReport />
      case "secondChecklist":
        return <SecondCheckList />
      case "grossreport":
        return <GrossSalary />
      case "nocForms":
        return <ListNoc />
      case "resignedEmployees":
        return <ViewEmployees isResigned={true} />;
      case "noticePeriodEmployees":
        return <ViewEmployees isNoticePeriod={true} />;
      case "permissionRequests":
        return <PersmissionRequests />
      case "show_special_permission":
        return <ShowSpecialPermission />
      case "approve_technical_issue":
        return <ApproveTI />
      case "onduty":
        return <PastOnduty />
      case "approvals":
        return <StatusUpdation />
      case "improperApproval":
        return <ViewImproperHr />
      case "hodChangeRequests":
        return <HodChange />
      case "changeHod":
        return <HodChange />
      case "tlChangeRequests":
        return <TlChange />
      case "changeTl":
        return <ChangeTl />
      case "changeEmpStatus":
        return <GetStatusChange />
      case "quickView":
        return <QuickView />
      case "activeEmployees":
        return <ActiveEmployees />
      case "inactiveEmployees":
        return <InactiveEmployees />
      case "empTransfer":
        return <EmpTransfer />
      case "teamattendance":
        return <ViewEmployeeAttendance />
      case "appliedOnDuty":
        return <PastOnduty />
      case "myattendance":
        return <ViewEmployeeAttendance />
      case "viewTicket":
        return <ListTickets />
      case "tickets":
        return <ListTickets />
      case "profile":
        return <EmployeeProfile onBack={() => setSelectedMenu("home")} />
      case "compOffApprovals":
        return <CompoffApproval />
      case "nocforms":
        return <ExitClearanceApprovalPage />
      case "finalapprovals":
        return <FinalApprovalsList />
      case "fnfapprovals":
        return <FinalSettlementApprovalsQueue />
      default:
        return null;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh", background: "#fff" }}>
      <DashboardHeader />

      {/* Mobile top menu toggle */}
      {isMobile && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            padding: "10px 20px",
            borderBottom: "1px solid #f0f0f0",
          }}
        >
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: "20px", color: "#0e497b" }} />}
            onClick={() => setDrawerVisible(true)}
          />
        </div>
      )}

      <Layout style={{ minHeight: "calc(100vh - 64px)", background: "#f8fafc" }}>
        {/* Desktop Sidebar */}
        {!isMobile && (
          <Sider
            width={260}
            collapsible
            collapsed={collapsed}
            onCollapse={(value) => setCollapsed(value)}
            theme="light"
            style={{
              background: "#fff",
              borderRight: "1px solid #e2e8f0",
              boxShadow: "2px 0 8px rgba(15,23,42,0.04)",
              position: "fixed",
              top: 64,
              left: 0,
              bottom: 0,
              zIndex: 900,
              overflowY: "auto",
            }}
          >

            <style>{`
              .ant-menu { background: #fff !important; border-right: none !important; padding: 10px 8px !important; }
              .ant-menu-item, .ant-menu-submenu-title { font-weight: 650 !important; font-size: 13.5px !important; color: #334155 !important; border-radius: 12px !important; margin-bottom: 5px !important; transition: background-color 0.15s ease, transform 0.15s ease !important; }
              .ant-menu-item:hover, .ant-menu-submenu-title:hover { background-color: rgba(14,73,123,0.06) !important; color: #0e497b !important; transform: translateX(3px) !important; }
              .ant-menu-item-selected { background: linear-gradient(135deg, #0e497b 0%, #1d4ed8 100%) !important; color: #ffffff !important; font-weight: 800 !important; border-left: 3.5px solid #38bdf8 !important; box-shadow: 0 4px 16px rgba(14,73,123,0.3) !important; transform: translateX(3px) !important; transition: none !important; }
              .ant-menu-item-selected, .ant-menu-item-selected *, .ant-menu-item-selected .ant-menu-title-content, .ant-menu-item-selected .anticon { color: #ffffff !important; transition: none !important; }
              .ant-menu-submenu-open > .ant-menu-submenu-title { color: #0e497b !important; font-weight: 800 !important; background-color: rgba(14,73,123,0.07) !important; }
            `}</style>

            <Menu
              mode="inline"
              selectedKeys={[selectedMenu]}
              openKeys={openKeys}
              onOpenChange={(keys) => setOpenKeys(keys)}
              onClick={({ key }) => {
                setSelectedMenu(key);
                const parents = keyParentMap[key] || [];
                setOpenKeys((prev) => Array.from(new Set([...prev, ...parents])));
              }}
              style={{ height: "100%", borderRight: 0, background: "#fff" }}
              items={menuItems}
            />
          </Sider>
        )}

        {/* Mobile Drawer Sidebar */}
        <Drawer
          title="Menu"
          placement="left"
          closable
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
          styles={{ body: { padding: 0 } }}
        >
          <Menu
            mode="inline"
            selectedKeys={[selectedMenu]}
            openKeys={openKeys}
            onOpenChange={(keys) => setOpenKeys(keys)}
            onClick={({ key }) => {
              setSelectedMenu(key);
              const parents = keyParentMap[key] || [];
              setOpenKeys((prev) => Array.from(new Set([...prev, ...parents])));
              setDrawerVisible(false);
            }}
            style={{ height: "100%", borderRight: 0, background: "#fff" }}
            items={menuItems}
          />
        </Drawer>

        {/* Main Content Area */}
        <Layout style={{
          marginLeft: isMobile ? 0 : (collapsed ? 80 : 260),
          transition: "margin-left 0.2s ease-in-out",
          padding: isMobile ? "12px" : "20px 24px",
          background: "#f8fafc",
          minHeight: "calc(100vh - 64px)",
          minWidth: 0,
          width: "100%",
        }}>
          <Content style={{ background: "transparent", minWidth: 0, width: "100%" }}>
            {renderContent()}
          </Content>
        </Layout>
      </Layout>

      {/* <Footer style={{ background: "#fff" }} /> */}
    </Layout>
  );
}
